export default __webpack_public_path__ + "2598b2c943f1424dde1a6beb2c0e58ab.svg";